import React from 'react';

interface ErrorMessageProps {
  message: string;
  type?: 'error' | 'warning' | 'info';
  onDismiss?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  type = 'error', 
  onDismiss 
}) => {
  const alertClasses = {
    error: 'alert-error',
    warning: 'alert-warning',
    info: 'alert-info'
  };

  return (
    <div className={`alert ${alertClasses[type]}`}>
      <div className="d-flex justify-content-between align-items-center">
        <span>{message}</span>
        {onDismiss && (
          <button 
            type="button" 
            className="btn btn-sm" 
            onClick={onDismiss}
            style={{ background: 'none', border: 'none', fontSize: '18px' }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;